<template>
  <div class="send-message-cta">
    <b-button
      v-if="!isTTSEnabled"
      pill
      class="sms-cta d-flex justify-content-center align-items-center px-0 py-0"
      variant="info"
      :disabled="isSending"
      @click="$emit('send-message')"
    >
      <b-spinner v-if="isSending" small></b-spinner>
      <feather v-else type="send" size="18" />
    </b-button>
    <template v-else>
      <b-dropdown class="tts-cta-dropdown" split variant="info" :disabled="isSending">
        <template #button-content>
          <span v-if="isSending" class="d-inline-flex w-100 h-100 justify-content-center align-items-center">
            <b-spinner small></b-spinner>
          </span>
          <span
            v-else
            class="d-inline-flex w-100 h-100 justify-content-center align-items-center"
            @click="$emit('send-message')"
          >
            <feather type="send" size="18" />
          </span>
        </template>
        <b-dropdown-item
          :active="value"
          @click="$emit('input', true)"
        >
          TTS
        </b-dropdown-item>
        <b-dropdown-item
          :active="!value"
          @click="$emit('input', false)"
        >
          SMS
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </div>
</template>

<script>
export default {
  name: "SendMessage",
  props: {
    value: Boolean,
    isSending: {
      type: Boolean,
      default: false,
    },
    isTTSEnabled: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<style lang="scss">
.send-message-cta {
  height: 40px;
  .sms-cta {
    width: 40px;
    height: 100%;
  }
  .tts-cta-dropdown {
    height: 100%;
    >button {
      &:nth-child(1) {
        width: 40px;
        padding: 0 !important;
      }
      &:nth-child(2) {

      }
    }
  }
}
</style>
